"use client";

import { Flex } from "@vetty/ui";

import styles from "./LoadingScreen.module.scss";

/**
 * LoadingScreen Component
 *
 * Full-viewport spinner and wordmark shown while the app or a page is loading.
 *
 * @returns Centered loading overlay
 */
const LoadingScreen = () => {
  return (
    <>
      {/* Full-viewport cover so the page underneath is hidden */}
      <Flex className={styles["comp"]} justify="center" align="center">
        {/* Centered spinner, wordmark, and status line */}
        <Flex gap={16} direction="column" justify="center" align="center">
          <div className={styles["comp__wrapper"]}>
            <div className={styles["comp__spinner"]} />

            <img
              className={styles["comp__logo"]}
              src="/assets/logo-symbol-dark.svg"
              alt="Vetty 3D"
            />
          </div>

          <div className={styles["comp__label"]}>
            The Vetty application is loading...
          </div>
        </Flex>
      </Flex>
    </>
  );
};

export { LoadingScreen };
